export enum ShopTypesServerSideEnum {
    clinic="shop",
    entOffice="entOffice"
}
